import { __ } from '../translations';
import { Footer as WCPFooter } from '@intigral/ui/components/Footer';
import useLanguage from '../hooks/useLanguage';
import { useFooterMenuQuery } from '../hooks/useFooterMenuQuery';

export const Footer = () => {
    const language = useLanguage();

    const { data, isLoading } = useFooterMenuQuery();

    if (isLoading) {
        return null;
    }

    const companyURL = `<a href=${__('home_footer_intigral_link')} target=_blank>${__('home_footer_intigral')}</a>`;
    const currentYear = new Date().getFullYear();

    const copyrights = __('home_footer_copyright_text', {
        COMPANY_URL: companyURL,
        YEAR: currentYear,
    });

    // const copyrights = __('home_footer_copyright') +
    //     ' ' +
    //     new Date().getFullYear() +
    //     ' <a href=' +
    //     __('home_footer_intigral_link') +
    //     'target=_blank>' +
    //     __('home_footer_intigral') +
    //     '</a>' +
    //     __('home_footer_all_right');

    const navlinks = data?.footerMenu?.map((link) => {
        return {
            text: language === 'ar' ? link.label.ar : link.label.en,
            link: language === 'ar' ? link.url.ar : link?.url.en,
            image: '',
            target: link.target,
        };
    });
    const socialLinks = data?.socialMediaLinks?.map((link) => {
        return {
            link: link.link,
            text: language === 'ar' ? link.label.ar : link.label.en,
            image: link.imageUrl,
            target: link.target,
        };
    });

    const mappedAppLinks = data.appLinks?.map((link) => {
        return {
            link: link.link,
            text: language === 'ar' ? link.label.ar : link.label.en,
            image: link.imageUrl,
            target: link.target,
        };
    });

    return (
        <>
            <WCPFooter
                navLinks={navlinks}
                appsLinks={mappedAppLinks}
                copyrightText={copyrights}
                socialMediaLinks={socialLinks}
                LinkComponent="a"
            />
        </>
    );
};
